// extracted by mini-css-extract-plugin
export default {"wrap":"StepWrap_wrap__K94Gd"};